import React from 'react';
import AcademicWorkspace from '../AcademicWorkspace';

export default function AdminAcademics({ defaultTab = 'overview' }) {
    return <AcademicWorkspace defaultTab={defaultTab} compact />;
}
